import _extends from "@babel/runtime/helpers/extends";
import isEmpty from 'lodash/isEmpty';
import { FOLDER_TYPE } from './consts';
import { translate } from './locales';
var parseName = function parseName(name) {
  var isFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var i18nKey = isFiles ? 'topFolder.projectFiles' : 'topFolder.forTheField';
  var folderName = name || '';
  if (folderName.indexOf('/') === 0) {
    return "".concat(translate(i18nKey)).concat(folderName);
  }
  if (folderName.indexOf('/') > 0) {
    var parts = folderName.split('/');
    parts[0] = translate(i18nKey);
    return parts.join('/');
  }
  return translate(i18nKey);
};

/**
 * Parse distributed folder display name
 */
export var parseDistributedName = function parseDistributedName(name) {
  return parseName(name, false);
};

/**
 * Parse documents folder display name
 */
export var parseDisplayName = function parseDisplayName(name) {
  return parseName(name, true);
};
export var isRootFolder = function isRootFolder(folder) {
  return folder.isSystemFolder || folder.isRoot;
};
export var isSharedFolder = function isSharedFolder(folder) {
  return folder && folder.folderType === FOLDER_TYPE.SHARED;
};
export var isSharedRootFolder = function isSharedRootFolder(folder) {
  return isSharedFolder(folder) && isRootFolder(folder);
};
export var isVirtualFolder = function isVirtualFolder(folder) {
  return folder && folder.folderType === FOLDER_TYPE.VIRTUAL;
};

// Use folderType, displayPathLocId, displayPath to localize displayPath, https://wiki.autodesk.com/x/84BELg
export var localizeFolderPath = function localizeFolderPath(folder) {
  if (![FOLDER_TYPE.PROJECT_FILE, FOLDER_TYPE.SHARED].includes(folder.folderType)) return folder;

  // Translate display local path if necessary
  var displayLocalPath = (folder.displayPathLocId || '').split('/').map(function (title) {
    if (title === FOLDER_TYPE.PROJECT_FILE) return parseDisplayName();
    if (['distributed', FOLDER_TYPE.SHARED].includes(title)) return parseDistributedName();
    return title;
  }).filter(function (item) {
    return !isEmpty(item);
  }).join('/');

  // Translate display path and also prefix display local path if required.
  var displayPath = (folder.displayPath || '').split('/').map(function (title, index) {
    if (index === 0 && !title) return displayLocalPath;
    if (title === FOLDER_TYPE.PROJECT_FILE) return parseDisplayName();
    if (['distributed', FOLDER_TYPE.SHARED].includes(title)) return parseDistributedName();
    return title;
  }).filter(function (item) {
    return !isEmpty(item);
  }).join('/');
  return _extends({}, folder, {
    displayPath: displayPath
  });
};

/**
 * Get folder title and translate for root folders
 */
export var getFolderTitle = function getFolderTitle(folder) {
  if (!folder) return undefined;
  if (isRootFolder(folder) && folder.folderType === FOLDER_TYPE.PROJECT_FILE) return translate('topFolder.projectFiles');
  if (isSharedRootFolder(folder)) return translate('topFolder.forTheField');
  return folder.title || folder.name;
};
export var parseFolderDisplayPath = function parseFolderDisplayPath(folder) {
  if (!folder || !folder.displayPath) return undefined;
  if (isSharedRootFolder(folder)) return translate('topFolder.forTheField');
  if (isRootFolder(folder)) return translate('topFolder.projectFiles');
  return folder.displayPath.split('/').map(function (title, index) {
    if (index === 0) {
      return translate("topFolder.".concat(folder.folderType === FOLDER_TYPE.PROJECT_FILE ? 'projectFiles' : 'forTheField'));
    }
    return title;
  }).join('/');
};